module.exports = __webpack_public_path__ + "fonts/tf_din_medium-subfont.5cc70d05.ttf";